const apply = {
  path: 'apply',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/apply'], resolve)
}
export default apply
